import { createApi } from '@reduxjs/toolkit/query/react';
import { transformErrorResponse, transformSucessResponse } from '../../utils/API/responseMiddleware';
import { defautBaseQuery } from '../../utils/API/fetchBaseQuery';
import { encryptQueryString, transformRequest } from '../../utils/API/requestMiddleware';


const syncDataAPI = createApi({
    baseQuery: defautBaseQuery, // Replace with your API endpoint
    reducerPath: 'syncDataAPI',
    endpoints: (builder) => ({
        addProductDataSync: builder.mutation({
            query: (details) => ({
                url: '/SyncData/AddProductDataSync',
                method: 'POST',
                body: transformRequest(details),
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),


        getAllProductDataSyncImportType: builder.query({
            query: () => ({
                url: (`/SyncData/GetAllProductDataSyncImportType`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        exportProductSyncAnalyzer: builder.query({
            query: () => ({
                url: `/SyncData/ExportProductSyncAnalyzer`,
                method: 'GET',
               responseHandler: async (response) => response.blob(),
            }),
           
            transformErrorResponse: transformErrorResponse,
        }),
        getDropDownData: builder.query({
            query: function (params) {
                const { url } = params;
          
                let {  ...retVal } = params.params;

                return {
                    url: params.url,
                    params: { queryRequest: JSON.stringify(retVal) }
                };
            },
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        deleteProductDataSyncByProductDataSyncId: builder.mutation({
            query: (productDataSyncId) => ({
                url: encryptQueryString(`/SyncData/DeleteProductDataSyncByProductDataSyncId/?productDataSyncId=${productDataSyncId}`),
                method: 'DELETE',
                body: transformRequest(productDataSyncId)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getProductDataSyncById: builder.query({
            query: (id) => ({
                url: encryptQueryString(`/SyncData/GetProductDataSyncById?id=${id}`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getProductDataSyncOutputFileById: builder.query({
            query: (id) => ({
                url: encryptQueryString(`/SyncData/GetProductDataSyncOutputFileById?id=${id}`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getRunningProductDataSyncList: builder.query({
            query: () => ({
                url: '/SyncData/GetRunningProductDataSyncList',
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        updateProductDataSync: builder.mutation({
            query: (details) => ({
                url: '/SyncData/UpdateProductDataSync',
                method: 'POST',
                body: transformRequest(details),
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        requeueRunningProductDataSync: builder.mutation({
            query: (details) => ({
                url: '/SyncData/RequeueRunningProductDataSync',
                method: 'POST',
                body: transformRequest(details),
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse
        }),
    })
});

export const {
     useAddProductDataSyncMutation,
    useLazyGetAllProductDataSyncImportTypeQuery,
    useLazyGetDropDownDataQuery,
    useLazyExportProductSyncAnalyzerQuery,
    useDeleteProductDataSyncByProductDataSyncIdMutation,
    useLazyGetProductDataSyncByIdQuery,
    useLazyGetProductDataSyncOutputFileByIdQuery,
    useLazyGetRunningProductDataSyncListQuery,
    useUpdateProductDataSyncMutation,
    useRequeueRunningProductDataSyncMutation,
} = syncDataAPI;

export default syncDataAPI;